module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="dropdown" style="'+
((__t=( style ))==null?'':__t)+
'">\n    <button id="contacts-select" class="btn btn-primary" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">\n        '+
((__t=( title ))==null?'':__t)+
'\n        <span class="caret"></span>\n    </button>\n    <ul class="dropdown-menu" aria-labelledby="contacts-select">\n        ';
 _.each(contacts, function(contact){ 
__p+='\n        <li><a name="'+
((__t=( generatedElNameFromContact(contact) ))==null?'':__t)+
'" class="clickable contact">'+
((__t=( generatedTitleFromContact(contact) ))==null?'':__t)+
'</a></li>\n        ';
 }) 
__p+='\n    </ul>\n</div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/common/contacts-select-view.html
// module id = 280
// module chunks = 0